<template>
  <p>
    For inquiries relating to the scientific content of the conference or sponsorship possibilities,
    please contact the VIZBI chairs:
  </p>
  <Email to="vizbi-contact" :outstanding="true" />
  <p>
    For inquiries about practical matters (registration, transport, hotels, etc.), please contact
    the EMBL Course and Conference Office:
  </p>
  <p style="margin-left: 2.5em;">
    Maryann Smith<br /><br />
    Tel: +49 6221 387-8760<br /><br />
    European Molecular Biology Laboratory<br />
    Meyerhofstra&szlig;e 1<br />
    69117 Heidelberg, Germany
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
